import { createApp, defineAsyncComponent } from 'vue';
import emitter from '../plugins/emitter';

const app = createApp({
    components: {
        VueShare: defineAsyncComponent(() => import('./Share.vue')),
    },
});

app.use(emitter);
app.mount('#vue__event__details');